export default __webpack_public_path__ + "static/media/FERRAMENTAS - 1.dfd3f763.png";